export enum UserIdentityType {
    AzureObjectId = 1,
}
